module.exports = "<div class=\"teal-murky\">\n    <span class=\"mb40 mt50 teal-murky col-md-12 p40 col-xs-12\">\n    <h2 class=\"teal-murky\">System unavailable</h2>\n    <div class=\"status_update teal-murky\">\n      <span class=\"h3\">{{applicationOfflineMsg}}</span>\n    </div>\n      </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/application-offline/application-offline.component.html
// module id = ./src/app/shared/components/application-offline/application-offline.component.html
// module chunks = main